import React from 'react';
import './Board.css';
import Block from './Block';
import { BlockModel } from './model/BlockModel';

export interface BlockViewModel {
  hue: number,
  x: number,
  y: number,
  block: BlockModel
};

interface BoardProps {
  blockViewModels: BlockViewModel[];
  width: number;
  height: number;
}

function Board(props: BoardProps) {
  const blockViewModels = props.blockViewModels;

  const blocks = blockViewModels.map((blockViewModel, index) => {
    return (
      <Block key={index} hue={blockViewModel.hue} offsetLeft={blockViewModel.x} offsetTop={blockViewModel.y} layout={blockViewModel.block.draw()}></Block>
    )
  });

  return (
    <div className={`board board--w${props.width} board--h${props.height}`}>
      {blocks}
    </div>
  );
}

export default Board;
